import httpService from "../../Service/httpService";

const controller = "Consultas";


export const getHorarios = async (id, fecha) => {
	const res = await httpService.get(`/${controller}/getHorarios/${id}/${fecha}`);
  return res.data;
}

export const getAntecedentes = async (id, idPac) => {
	const res = await httpService.get(`/${controller}/getAntecedentes/${id}/${idPac}`);
  return res.data;
}

export const getPaciente = async (id, tel) => {
  const res = await httpService.get(`/${controller}/getPaciente/${id}/${tel}`);
  return res.data;
}

export const getPacienteXNombre = async (id) => {
  const res = await httpService.get(`/${controller}/getPacienteXNombre/${id}`);
  return res.data;
}

export const getTelefonoXNombre = async (id, nombre) => {
	const res = await httpService.get(`/${controller}/getTelefonoXNombre/${id}/${nombre}`);
	return res.data;
}

export const getCitas = async (id, idServicio, date, estatus) => {
  const res = await httpService.get(`/${controller}/getCitas/${id}/${idServicio}/${date}/${estatus}`);
  return res.data;
}

export const getConsultorio = async (id, idMedico) => {
  const res = await httpService.get(`/${controller}/getConsultorio/${id}/${idMedico}`);
  return res.data;
}

export const getDatosAgendaCita = async (id, idServicio, idPac, fecha, hora) => {
  const res = await httpService.get(`/${controller}/getDatosAgendaCita/${id}/${idServicio}/${idPac}/${fecha}/${hora}`);
  return res.data;
}

export const getDatosCitaPorIdConsulta = async (id, idConsulta) => {
  const res = await httpService.get(`/${controller}/getDatosCitaPorIdConsulta/${id}/${idConsulta}`);
  return res.data;
}

//getDatosCita
export const getDatosCita = async (id, idPac, fecha) => {
  const res = await httpService.get(`/${controller}/getDatosCita/${id}/${idPac}/${fecha}`);
  return res.data;
}

export const getTelefonoXID = async (id, nombre) => {
  const res = await httpService.get(
    `/${controller}/getTelefonoXID/${id}/${nombre}`,
  );
  return res.data;
};

export const getDocsCita = async (id, idConsulta) => {
  const res = await httpService.get(`/${controller}/getDocsCita/${id}/${idConsulta}`);
  return res.data;
}

export const getListaPacientes = async (id) => {
  const res = await httpService.get(`/${controller}/getListaPacientes/${id}`);
  return res.data;
};

export const getHistoricoCitas = async (id, idPac) => {
  const res = await httpService.get(`/${controller}/getListaCitas/${id}/${idPac}`);
  return res.data;
};



export const getEstadoIMC = async (imc) => {
  const res = await httpService.get(`/${controller}/getEstadoIMC/${imc}`);
  return res.data;
};

export const getExploraFisicaItems = async (id) => {
  const res = await httpService.get(`/${controller}/getItemsExploraFis/${id}`);
  return res.data;
};

//getExpedAnterior
export const getExpedAnterior = async (id, idPac) => {
  const res = await httpService.get(`/${controller}/getExpedAnterior/${id}/${idPac}`);
  return res.data;
};

//getHorariosDia
export const getHorariosDia = async (id, idMedico, idServicio, fecha) => {
  const res = await httpService.get(`/${controller}/getHorariosDia/${id}/${idMedico}/${idServicio}/${fecha}`);
  return res.data;
};

//getPacienteProgramado
export const getPacienteProgramado = async (id, idServicio, hora) => {
  const res = await httpService.get(`/${controller}/getPacienteProgramado/${id}/${idServicio}/${hora}`);
  return res.data;
};

//LISTA DE PACIENTES CON CITA POR FECHA Y HORA
export const getListDetallesProgram = async (id, idServicio, fecha, hora) => {
  const res = await httpService.get(`/${controller}/getListDetallesProgram/${id}/${idServicio}/${fecha}/${hora}`);
  return res.data;
};


export const getSesionesHemo = async (id, idPac) => {
  const res = await httpService.get(`/${controller}/getSesionesHemo/${id}/${idPac}`);
  return res.data;
};


export const saveCita = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/save`, {
		...data,
	});
	return res;
};

export const saveCancelCita = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/cancelarCita`, {
		...data,
	});
	return res;
};

export const saveCancelCitaMedico = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/cancelarCitaMedico`, {
		...data,
	});
	return res;
};


//saveItem
export const saveItem = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/saveItem`, {
		...data,
	});
	return res;
};

export const saveUpdateCita = async (data) => {
	//   const userData = getDecodedToken();
	const res = await httpService.post(`/${controller}/updateCita`, {
		...data,
	});
	return res;
};

export const saveConsulta = async (formData) => {
  try {
    const response = await httpService.post(`/${controller}/saveConsulta`, formData, {
      headers: {
        // Axios automatically sets the correct Content-Type for FormData,
        // but explicitly setting it to multipart/form-data can also work
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};


export const saveDoc = async (formData) => {
  try {
    const response = await httpService.post(`/${controller}/saveDoc`, formData, {
      headers: {
        // Axios automatically sets the correct Content-Type for FormData,
        // but explicitly setting it to multipart/form-data can also work
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};